export const BrandLoaderMark = () => (
  <div className="brand-loader" role="status" aria-label="Loading">
    <div className="brand-loader-stage">
      <div className="brand-loader-tile">
        <img src="/logoNew.svg" alt="Trangile" className="brand-loader-logo" />
        <span className="brand-loader-shine" aria-hidden />
      </div>
    </div>
    <span className="brand-loader-floor" aria-hidden />
  </div>
);

export const DotLoaderMark = () => (
  <div className="dot-loader" role="status" aria-label="Loading">
    <span />
    <span />
    <span />
  </div>
);

const Loader = ({ variant = "dots" }) => (
  <div className={`stripe-loader-overlay stripe-loader-overlay-${variant}`}>
    {variant === "brand" ? <BrandLoaderMark /> : <DotLoaderMark />}
  </div>
);

export default Loader;
